/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLearnMoreDto } from '../../models/create-learn-more-dto';
import { LearnMoreResponseAdminDto } from '../../models/learn-more-response-admin-dto';

export interface AdminLearnMoreControllerCreateLearnMoreV1$Params {
      body: CreateLearnMoreDto
}

export function adminLearnMoreControllerCreateLearnMoreV1(http: HttpClient, rootUrl: string, params: AdminLearnMoreControllerCreateLearnMoreV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LearnMoreResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminLearnMoreControllerCreateLearnMoreV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LearnMoreResponseAdminDto>;
    })
  );
}

adminLearnMoreControllerCreateLearnMoreV1.PATH = '/v1/admin/learn-more';
